import { autoinject, bindable, DOM, bindingMode, Parent } from 'aurelia-framework';
import { ValidationController, ValidationRules, validateTrigger, Validator } from 'aurelia-validation';

@autoinject()
export class WorkCarrierInput {

    constructor() {
    }

    @bindable({ defaultBindingMode: bindingMode.oneTime }) field: string;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) approvals: Array<any>;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) dotValues: Array<any>;
    @bindable({ defaultBindingMode: bindingMode.oneTime }) class: string;

    bind() {
    }

    //triggerEvent = (type:string) => this.element.dispatchEvent(DOM.createCustomEvent(type, {}));

}
